module.exports = __webpack_public_path__ + "img/1445373496.21213542.jpg";